import Monitoring from 'shared_modules/Monitoring';

export const hideGuiDefsElements = (elements: any[]) => {
  elements.forEach((id) => {
    const element = document.getElementById(id);
    if (element) {
      element.style.display = 'none';
    }
  });
};

/**
 * Run a callback function after changing an option in the drop-down.
 * By passing a string, it's assumed the function is globally available in the window object.
 *
 * @param {string|function} callback
 * @param  {...any} args
 */
export const runOnChangeCallbackFunc = (
  callback: string | ((arg: any[]) => void),
  ...args: any[]
) => {
  const typeOfCallback = typeof callback;
  try {
    switch (typeOfCallback) {
      case 'function':
        // @ts-ignore
        callback(...args);
        break;
      case 'string':
        // @ts-ignore
        window[callback](...args);
        break;
      default:
        throw new Error(`${typeOfCallback} is not supported for callback function.`);
    }
  } catch (err) {
    Monitoring.addError(err, 'runOnChangeCallbackFunc', { callback, ...args });
  }
};

export const runOnChangeCallbackFuncAsString = (onChange: string) => {
  const [, rawFn, rawParam] = onChange.replace(/'/g, '').match(/(.+)\((.+?)\)/) || [];
  const fn = rawFn?.trim();
  const param = rawParam?.replace(/&quot;/g, '"');

  // @ts-ignore Warning: function check on window scope
  if (typeof window[fn] === 'function') {
    // @ts-ignore
    window[fn].apply(
      null,
      param.split(',').map((p) => p.trim())
    );
  }
};
